/**
 * Operator role (B.9–B.11) icon set — cyberpunk line-icons, currentColor, no
 * emoji. Tab icons: clean 24×24 round-stroke set. Dashboard glyphs: ported
 * from screen-09-op-dashboard.html.
 */
import type { SVGProps } from "react";

type P = SVGProps<SVGSVGElement>;

/* 24×24 round-stroke tab icons */
function T({ children, ...rest }: P) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...rest}>
      {children}
    </svg>
  );
}

export const TabGames = (p: P) => (
  <T {...p}><rect x="2" y="6" width="20" height="12" rx="5" /><path d="M6 11h4M8 9v4" /><circle cx="15.5" cy="11" r="1" /><circle cx="17.5" cy="13.5" r="1" /></T>
);
export const TabUni = (p: P) => ( /* 28.09: «Юниверситет» вместо заглушки Skills — шапочка выпускника */
  <T {...p}><path d="M2 9.5L12 5l10 4.5L12 14z" /><path d="M6 11.3V16c0 1.6 2.7 3 6 3s6-1.4 6-3v-4.7M22 9.5V15" /></T>
);
export const TabSchedule = (p: P) => (
  <T {...p}><rect x="3" y="4" width="18" height="17" rx="2" /><path d="M3 9h18M8 2v4M16 2v4" /></T>
);
export const TabReports = (p: P) => (
  <T {...p}><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><path d="M14 3v6h6M8 13h8M8 17h6" /></T>
);
export const TabSalary = (p: P) => (
  <T {...p}><circle cx="12" cy="12" r="9" /><path d="M9.5 17V7h3.2a2.4 2.4 0 0 1 0 4.8H8M8 14.2h5.2" /></T>
);
export const TabTelegram = (p: P) => (
  <T {...p}><path d="M21 4L3 11l6 2.5L11 20l3-4 4 1.2z" /><path d="M9 13.5L21 4" /></T>
);
export const TabExtra = (p: P) => (
  <T {...p}><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" /></T>
);
export const TabBounty = (p: P) => (
  <T {...p}><rect x="3" y="8" width="18" height="13" rx="1" /><path d="M3 12h18M12 8v13" /><path d="M12 8s-1-5-4-5a2.5 2.5 0 0 0 0 5zM12 8s1-5 4-5a2.5 2.5 0 0 1 0 5z" /></T>
);
/* «Анкета» tab — ID-card / dossier glyph. */
export const TabAnketa = (p: P) => (
  <T {...p}><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="9" cy="10" r="2" /><path d="M5.5 16a3.5 3.5 0 0 1 7 0M15 9h4M15 12h4M15 15h2" /></T>
);

/* dashboard glyphs (screen-09 emphasis sizes; square caps) */
function S({ vb = "0 0 12 12", sw = 1.6, fill = "none", children, ...rest }: P & { vb?: string; sw?: number }) {
  return (
    <svg viewBox={vb} fill={fill} stroke={fill === "none" ? "currentColor" : "none"} strokeWidth={sw} strokeLinecap="square" strokeLinejoin="miter" {...rest}>
      {children}
    </svg>
  );
}
export const Bolt = (p: P) => (<S vb="0 0 18 18" fill="currentColor" {...p}><path d="M10 1L3 10h5l-2 7 9-10h-5l2-6z" /></S>);
export const Check = (p: P) => (<S vb="0 0 14 14" sw={1.8} {...p}><path d="M3 7.5l3 3 5-6" /></S>);
export const Bell = (p: P) => (<S {...p}><circle cx="6" cy="6" r="5" /><path d="M6 4v2.5l1.5 1" /></S>);
export const WarnTri = (p: P) => (<S {...p}><path d="M6 1L11 10H1L6 1z" /><path d="M6 5v2M6 8.5v.5" /></S>);
export const Person = (p: P) => (<S {...p}><circle cx="6" cy="4" r="2" /><path d="M2 11v-1a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v1" /></S>);
export const Tea = (p: P) => (<S vb="0 0 14 14" {...p}><path d="M2 5h8v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5z" /><path d="M10 6h1.5a1.5 1.5 0 0 1 0 3H10" /><path d="M5 2v1M7 2v1" /></S>);
export const Coin = (p: P) => (<S vb="0 0 14 14" {...p}><circle cx="7" cy="7" r="5" /><path d="M7 4v6M5 5h3M5 7h3" /></S>);
export const ChevL = (p: P) => (<S vb="0 0 13 13" sw={1.8} {...p}><path d="M8.5 2.5 4 6.5l4.5 4" /></S>);
export const ChevR = (p: P) => (<S vb="0 0 13 13" sw={1.8} {...p}><path d="M4.5 2.5 9 6.5l-4.5 4" /></S>);

/* B.11 Game Report modal glyphs */
export const RDoc = (p: P) => (<S vb="0 0 14 14" {...p}><rect x="3" y="1.5" width="8" height="11" /><path d="M5 5h4M5 7h4M5 9h2.5" /></S>);
export const RClose = (p: P) => (<S vb="0 0 11 11" sw={1.8} {...p}><path d="M2 2l7 7M9 2l-7 7" /></S>);
export const RBars = (p: P) => (<S {...p}><rect x="1" y="2" width="10" height="8" /><path d="M3 5h6M3 7h6" /></S>);
export const RText = (p: P) => (<S {...p}><path d="M2 3h8v6H6L3 11V9H2V3z" /></S>);
export const RGrid = (p: P) => (<S {...p}><rect x="1" y="2" width="10" height="8" /><path d="M1 5h10" /></S>);
export const RCar = (p: P) => (<S vb="0 0 18 18" {...p}><path d="M3 11V7l1.5-4.5h9L15 7v4" /><rect x="2" y="11" width="14" height="4" /><circle cx="5.5" cy="14.5" r="1" /><circle cx="12.5" cy="14.5" r="1" /></S>);
export const RPlane = (p: P) => (<S sw={1.8} {...p}><path d="M2 6L10 1.5L8 11L5 7.5L2 6z" /></S>);
export const RPeer = (p: P) => (<S {...p}><circle cx="4.5" cy="5" r="2" /><path d="M1.5 11v-1a2.5 2.5 0 0 1 2.5-2.5h1" /><circle cx="9" cy="6" r="1.5" /><path d="M6.5 11v-.5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v.5" /></S>);

/* ── «Анкета» cabinet glyphs (sub-nav, profile/news/media editors) ────────── */
/** Profile / dossier ID card. */
export const AProfile = (p: P) => (<S vb="0 0 14 14" {...p}><rect x="1.5" y="2.5" width="11" height="9" /><circle cx="5" cy="6" r="1.6" /><path d="M2.5 10a2.5 2.5 0 0 1 5 0M9 5.5h2.5M9 8h2" /></S>);
/** News / megaphone. */
export const ANews = (p: P) => (<S vb="0 0 14 14" {...p}><path d="M2 5.5v3l6 2.5V3L2 5.5z" /><path d="M2 5.5H1v3h1M8 4.5l3-1.5v8l-3-1.5" /></S>);
/** Media / image grid. */
export const AMedia = (p: P) => (<S vb="0 0 14 14" {...p}><rect x="1.5" y="2.5" width="11" height="9" /><circle cx="5" cy="5.5" r="1" /><path d="M1.5 9.5L5 7l3 2.5 2-1.5 1.5 1.5" /></S>);
/** Crop corners. */
export const ACrop = (p: P) => (<S vb="0 0 14 14" {...p}><path d="M4 1v9h9M1 4h9v9" /></S>);
/** Filter / magic wand. */
export const AWand = (p: P) => (<S vb="0 0 14 14" {...p}><path d="M3 11L9 5M9.5 2v2M11 3l-1.4 1.4M12 5.5h-2M9.5 7V5" /></S>);
/** Upload arrow into tray. */
export const AUpload = (p: P) => (<S vb="0 0 14 14" {...p}><path d="M7 9V2M4.5 4.5L7 2l2.5 2.5" /><path d="M2.5 9v2.5h9V9" /></S>);
/** Fan-club lock (heart-lock). */
export const AFan = (p: P) => (<S vb="0 0 14 14" {...p}><path d="M7 11S2.5 8.2 2.5 5.2A2.2 2.2 0 0 1 7 4.4 2.2 2.2 0 0 1 11.5 5.2C11.5 8.2 7 11 7 11z" /></S>);
/** Eye — public visibility. */
export const AEye = (p: P) => (<S vb="0 0 14 14" {...p}><path d="M1 7s2.2-4 6-4 6 4 6 4-2.2 4-6 4-6-4-6-4z" /><circle cx="7" cy="7" r="1.6" /></S>);
/** Plus. */
export const APlus = (p: P) => (<S vb="0 0 12 12" sw={1.8} {...p}><path d="M6 2v8M2 6h8" /></S>);
/** Trash. */
export const ATrash = (p: P) => (<S vb="0 0 14 14" {...p}><path d="M2.5 3.5h9M5 3.5V2h4v1.5M3.5 3.5l.6 8h5.8l.6-8M5.5 6v4M8.5 6v4" /></S>);
/** Paper-plane send. */
export const ASend = (p: P) => (<S vb="0 0 14 14" sw={1.7} {...p}><path d="M2 7L12 2L9.5 12L6.5 8.5L2 7z" /></S>);
/** Pencil edit. */
export const AEdit = (p: P) => (<S vb="0 0 14 14" {...p}><path d="M9.5 2.5l2 2L5 11l-2.5.5L3 9l6.5-6.5z" /></S>);
/** Play triangle (video asset). */
export const APlay = (p: P) => (<S vb="0 0 14 14" fill="currentColor" {...p}><path d="M4 2.5l7 4.5-7 4.5z" /></S>);
/** Chevron down. */
export const AChevDown = (p: P) => (<S vb="0 0 12 12" sw={1.8} {...p}><path d="M2.5 4.5L6 8l3.5-3.5" /></S>);
/** Check / done. */
export const ACheck = (p: P) => (<S vb="0 0 14 14" sw={1.8} {...p}><path d="M3 7.5l3 3 5-6" /></S>);
